import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ModalPanel } from '@els/els-react--modal-panel';
import { ButtonWithIcon } from '@els/els-react--button';
import useBreakpoint from '@Hooks/useBreakpoint';
import GeneralMenuItems from '@Containers/Header/GeneralMenuItems';
import HamburgerMenu from '@Containers/Header/HamburgerMenu';
import DashboardNavigationControls from '@Containers/Header/DashboardNavigation/DashboardNavigationControls';
import { isReaxysAllowed } from '@Services/Auth/AuthHelper';
import WhyRegisterContent from './WhyRegisterContent';

function UnauthSiteNavigation({ isAnonShibbolethLogin, isAnonymousUser }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isTabletOrBelow = useBreakpoint('tablet');
  const showWhyRegister = !(isAnonymousUser && isReaxysAllowed());

  return (
    <>
      {!showWhyRegister && (
        <div className="u-els-display-none@tablet">
          <GeneralMenuItems />
        </div>
      )}
      <div className="u-els-display-flex u-els-align-items-center">
        {showWhyRegister && isReaxysAllowed() && (
          <ButtonWithIcon
            sprite="InformationOutlineCircle"
            linkIconSize="xs"
            type="link"
            data-e2e="why-register-button"
            iconOnly={!isTabletOrBelow}
            iconRight
            onClick={() => setIsModalOpen(true)}>
            Why register on Reaxys
          </ButtonWithIcon>
        )}
        <div className="u-els-display-flex u-els-align-items-center u-els-display-none@tablet">
          <DashboardNavigationControls isAnonymousUser={isAnonymousUser} />
        </div>
        {!isAnonShibbolethLogin && (
          <ul>
            <HamburgerMenu isAnonymousUser />
          </ul>
        )}
      </div>
      {isModalOpen && (
        <ModalPanel
          modalProps={{
            onClose: () => setIsModalOpen(false),
          }}
          panelPosition="right">
          <WhyRegisterContent />
        </ModalPanel>
      )}
    </>
  );
}

UnauthSiteNavigation.propTypes = {
  isAnonShibbolethLogin: PropTypes.bool,
  isAnonymousUser: PropTypes.bool.isRequired,
};

export default UnauthSiteNavigation;
